import { Agencies } from './../../models/agencies';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';
import { BiensImmobs } from 'app/models/biensImmobs';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { NgForm } from '@angular/forms';

import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
selector: 'app-meilleurs-bien-sousse',
templateUrl: './meilleurs-bien-sousse.component.html',
styleUrls: ['./meilleurs-bien-sousse.component.scss']
})
export class MeilleursBienSousseComponent implements OnInit {
  agencyForm: NgForm;
  public idAgency: any
  public Agency: any
public MeilleursBiens: any
p: Number = 1;
public search: string = ''
closeResult = '';
search_name1:any;
agencies: any[];
dataSource = new MatTableDataSource();
public AgenciesSousse: any
agenciedData: Agencies;
constructor(private meilleursBiensService: MeilleursBiensService,
private searchService: SearchService) { }

ngOnInit(): void {
this.getMeilleursBiensSousse();

}
getMeilleursBiensSousse() {
this.meilleursBiensService.getMeilleursBiensSousse().subscribe((data: any) => {


  this.MeilleursBiens = data;
 
    console.log('meilleurs biens sousse',this.MeilleursBiens)
    this.agencies = this.AgenciesSousse.filter((biens: any) => {
      return biens.region === 'SOUSSE';
      this.performSearch(); // Filtre uniquement les promoteurs ayant la région "Sousse"
    });


})}


SupprimerMeilleursBiens(MeilleursBiens, i) {
  Swal.fire({
    title: "Êtes-vous sûr(e) ?",
    text: "Vous ne pourrez pas revenir en arrière !",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimez-le."
  }).then((result) => {
    if (result.isConfirmed) {
      this.meilleursBiensService.deleteMeilleursBiens(MeilleursBiens.id).subscribe((response: any) => {

        // If you want to show a success message after the deletion, use another Swal.fire here
        Swal.fire({
          title: "Supprimé!",
          text: "Votre agence a été supprimée.",
          icon: "success"
        });
        // Fetch the updated data after deletion
        // setTimeout(() => {
        //   this.getagencesSousse();
        // }, 500);

      });
      this.MeilleursBiens.splice(i, 1)

    }
  });
}
// Méthode pour effectuer la recherche
performSearch() {
  this.MeilleursBiens = this.searchService.search(this.MeilleursBiens, this.search);
}}
